














































import { Component, Vue } from 'vue-property-decorator'
import { addInstance } from '../shared/instance-http'
import { httpErrorToString } from '../shared/utils'

@Component
export default class InstanceAdd extends Vue {
  host = ''
  err = ''
  successForHost = ''
  loading = false

  onSubmit (event: Event) {
    event.preventDefault()

    this.loading = true
    this.err = ''
    this.successForHost = ''

    addInstance(this.host)
      .then(() => {
        this.loading = false
        this.successForHost = this.host
        this.host = ''
      })
      .catch(err => {
        this.loading = false
        this.err = httpErrorToString(err)
      })
  }
}
